import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './errorBlock.scss';
import NotFoundPage from "./NotFoundPage";

class ErrorBlock extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error,
            errorInfo
        });
        // You can also log error messages to an error reporting service here
    }

    componentDidUpdate(prevProps) {
        if (this.props.path !== prevProps.path && this.state.errorInfo) {
            this.setState({
                error: null,
                errorInfo: null
            });
        }
    }

    render() {
        if (this.state.errorInfo) {
            // Error path
            return (
                <NotFoundPage/>
            );
        } else {
            // Normally, just render children
            return this.props.children ?? null;
        }
    }
}

ErrorBlock.propTypes = {
    path: PropTypes.string,
    children: PropTypes.node
};

export default ErrorBlock;
